
// Función que toma una lista de chats y filtra el id del chat que se desea eliminar,
// para retornar la lista actualizada sin ese chat.

export const deleteChat = (data, chats, setChats, setChatsArray) => {
    if(chats){
        console.log("este es el chat a eliminarse: ", data)
    // Filtrar el chat con el IdChat proporcionado en data y devolver la lista de chats sin él
    console.log("la lista vieja de chats", chats);
    const updatedChats = chats.filter(chat => chat.IdChat !== data);
    console.log("la lista nueva de chats", updatedChats)
    // Actualizar el estado con la lista de chats actualizada
    setChats(updatedChats);
    setChatsArray(updatedChats);
}
};
